// import React from "react";

// import "./App.css";
// import HomePage from "./Components/Home/HomePage";

// function App() {
//   return (
//     <div className="App">
//       <HomePage />
//     </div>
//   );
// }

// export default App;

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HomePage from "./Components/Home/HomePage";
import GarudaSenaDetails from "./Components/GarudaSenaDetails/GarudaSenaDetails";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AboutUs from "./Components/AboutUs/AboutUs";
import TrusteeMembers from "./Components/TrusteeMembers/TrusteeMembers";
import OurJourney from "./Components/OurJourney/OurJourney";
import Certificate from "./Components/Certificate/Certificate";
import TermsConditions from "./Components/TermsConditions/TermsConditions";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import CancellationRefundPolicy from "./Components/CancellationRefundPolicy/CancellationRefundPolicy";
import ContactUs from "./Components/ContactUs/ContactUs";
import AdminLogin from "./Components/Admin/AdminLogin";
import AdminDashboard from "./Components/Admin/AdminDashboarb";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute"; 
import EnrollForm from "./Components/EnrollForm/EnrollForm";

import Galleryy from "./Components/Gallery/Galleryy";
import PaymentStatus from "./Components/PaymentStatus/PaymentStatus";
import VolunteerCards from "./Components/VolunteerCards/VolunteerCards";
import VipMembers from "./Components/VipMembers/VipMembers";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/trustee-members" element={<TrusteeMembers />} />
        <Route path="/our-journey" element={<OurJourney />} />
        <Route path="/certification" element={<Certificate />} />
        <Route path="/admin-login" element={<AdminLogin />} />
         <Route path="/admin-dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund" element={<CancellationRefundPolicy/>}/> 
        <Route path="/contact" element={<ContactUs/>}/>
        <Route path="/garuda-sena-details" element={<GarudaSenaDetails />} />
        <Route path="/enroll" element={<EnrollForm />} />
        <Route path="/gallery" element={<Galleryy />} />
         <Route path="/volunteers" element={<VolunteerCards />} />
         <Route path="/vip-members" element={<VipMembers/>}/>
        <Route path='/payment/status/:orderId/:clientId' element={<PaymentStatus />} />
      </Routes>
    </Router>
  );
}

export default App;
